import { render, staticRenderFns } from "./VoteDialog.vue?vue&type=template&id=af09f506&scoped=true"
import script from "./VoteDialog.vue?vue&type=script&lang=js"
export * from "./VoteDialog.vue?vue&type=script&lang=js"
import style0 from "./VoteDialog.vue?vue&type=style&index=0&id=af09f506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af09f506",
  null
  
)

export default component.exports